const ecpRoutes = [
  {
    path: "/diag",
    name: "",
    meta: {
      title: "GQF 역량진단",
    },
    children: [
      /** GQF 역량진단 */
      {
        path: "core", // /diag/core
        name: "diagCore",
        meta: {
          title: "GQF 역량진단",
          menuCd: "STUDENT_DIAG_CORE",
        },
        children: [
          {
            path: "", // /diag/core
            name: "diagCoreIndex",
            meta: {
              title: "GQF 역량 유형 및 진단 소개",
              menuCd: "STUDENT_DIAG_CORE",
            },
            component: () => import("@/views/student/diag/core/StudentDiagIntro.vue"),
          },
          {
            path: "take", // /diag/core/take
            name: "diagCoreTake",
            meta: {
              title: "진단 응시",
              menuCd: "STUDENT_DIAG_CORE",
              isDynamic: true,
            },
            component: () => import("@/views/student/diag/cmmn/DiagAbilityTake.vue"),
          },
        ],
      },
      {
        path: "take", // /diag/take
        name: "diagTake",
        meta: {
          title: "GQF 역량진단 응시",
          menuCd: "STUDENT_DIAG_CORE",
          isDynamic: true,
        },
        component: () => import("@/views/student/diag/core/DiagCoreIndex.vue"),
      }, //StudentDiagIndex.vue  DiagCoreIndex.vue
    ],
  },
];

export default ecpRoutes;
